import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormFieldName } from 'src/app/core/constants/form.constants';
import { ReCaptchaAction } from 'src/app/core/models/reCaptcha.request';
import { IAddressSuggestion, PostalCodeCheckRequest } from '../../content-blocks/registration-form/address.model';

export const addressSuggestionValidator =
  (
    verifyFn: (
      action: string,
      request: PostalCodeCheckRequest,
      callback: (request: PostalCodeCheckRequest) => Promise<IAddressSuggestion>
    ) => Promise<IAddressSuggestion>,
    checkPostalCodeFn: (request: PostalCodeCheckRequest) => Promise<IAddressSuggestion>
  ) =>
  async (control: AbstractControl): Promise<ValidationErrors | null> => {
    const formControls = control.parent?.controls;
    const postalCodeControl = formControls ? (formControls[FormFieldName.postalCode] as AbstractControl) : null;
    const houseNumberControl = formControls ? (formControls[FormFieldName.houseNumber] as AbstractControl) : null;
    const streetControl = formControls ? (formControls[FormFieldName.streetName] as AbstractControl) : null;
    const cityControl = formControls ? (formControls[FormFieldName.city] as AbstractControl) : null;

    if (!postalCodeControl?.value || postalCodeControl?.invalid || !houseNumberControl?.value || houseNumberControl?.invalid) {
      return null;
    }

    const request = {
      postalCode: postalCodeControl?.value ?? '',
      houseNumber: houseNumberControl?.value ?? '',
      reCaptchaToken: ''
    } as PostalCodeCheckRequest;

    const promise = verifyFn(ReCaptchaAction.getAddressSuggestion, request, checkPostalCodeFn);

    const result: ValidationErrors | null = (await promise
      .then((response) => {
        if (response?.streetName && response.city) {
          streetControl?.setValue(response.streetName);
          cityControl?.setValue(response.city);
          streetControl?.disable();
          cityControl?.disable();
        } else {
          streetControl?.enable();
          cityControl?.enable();
        }
        return null;
      })
      .catch(() => {
        streetControl?.enable();
        cityControl?.enable();
      })) as ValidationErrors | null;
    return result;
  };
